import React from "react";
import { Link, NavLink } from "react-router-dom";

const customerCareLinks = [
  { to: "/shipping", label: "Shipping" },
  { to: "/returns", label: "Returns" },
  { to: "/contact", label: "Contact us" },
  { to: "/faqs", label: "FAQs" },
  { to: "/terms", label: "Terms of use" },
  { to: "/privacy", label: "Privacy" },
  { to: "/cookies", label: "Cookies" },
];

function PolicyLayout({
  eyebrow = "Customer care",
  title,
  intro,
  updated,
  sections = [],
  action,
  notice = null,
}) {
  return (
    <main className="policy-page">
      <header className="policy-page__hero">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {intro && <p>{intro}</p>}
        {updated && <p className="policy-page__updated">{updated}</p>}
      </header>

      {notice && (
        <aside className="policy-page__notice" aria-label="Important notice">
          <strong>Important notice</strong>
          <p>{notice}</p>
        </aside>
      )}

      <div className="policy-page__layout">
        <aside className="policy-page__aside">
          <nav aria-label="Customer care navigation">
            <p>Customer care</p>
            {customerCareLinks.map((link) => (
              <NavLink
                className={({ isActive }) =>
                  `policy-page__nav-link${isActive ? " is-active" : ""}`
                }
                end
                key={link.to}
                to={link.to}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <div className="policy-page__content">
          {sections.map((section) => (
            <section
              className="policy-section"
              id={section.id}
              key={section.id || section.title}
            >
              <h2>{section.title}</h2>
              {section.body?.map((paragraph, index) => (
                <p key={`${section.id || section.title}-paragraph-${index}`}>
                  {paragraph}
                </p>
              ))}
              {section.items && (
                <ul>
                  {section.items.map((item, index) => (
                    <li key={`${section.id || section.title}-item-${index}`}>
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {section.table && (
                <dl className="policy-table" aria-label={section.title}>
                  {section.table.map((row) => (
                    <div className="policy-table__row" key={row[0]}>
                      <dt>{row[0]}</dt>
                      <dd>{row[1]}</dd>
                    </div>
                  ))}
                </dl>
              )}
              {section.links && (
                <nav
                  className="policy-section__links"
                  aria-label={`${section.title} related links`}
                >
                  {section.links.map((link) => (
                    <Link key={link.to} to={link.to}>
                      {link.label}
                    </Link>
                  ))}
                </nav>
              )}
            </section>
          ))}
          {action && (
            <Link className="policy-page__action" to={action.to}>
              {action.label}
            </Link>
          )}
        </div>
      </div>
    </main>
  );
}

export default PolicyLayout;
